<template>
  <CContainer fluid>
    <h3>Garantías</h3>
    <CCard class="mt-4">
      <CCardBody class="p-3">
        <CRow>
          <CCol col="6">
            <CInput 
              label="Buscar:"
              placeholder="Buscar"
              addLabelClasses="text-muted font-weight-bold"
              :value.sync="searchWord"
              @keyup.enter="getData(1, searchWord)">
              <template #prepend-content>
                <a href="#" 
                  @click="() => {
                    searchWord = '';
                    getData(1);
                  }">
                  <i class="bi bi-arrow-clockwise"></i>
                </a>
              </template>
              <template #append-content>
                <a href="#" 
                  @click="getData(1, searchWord)">
                  <i class="bi bi-search"></i>
                </a>
              </template>
            </CInput>
          </CCol>
          <CCol col="6" class="d-flex justify-content-end align-items-center">
            <CButton
              color="success"
              :to="endpointAddRentContract">
              <i class="bi bi-plus-circle h4 align-middle mr-2"></i>
              <span>Agregar Contrato</span>
            </CButton>
            <CButton 
              color="dark" 
              variant="outline"
              class="ml-2"
              @click="(e) => downloadReportRentedProducts(e)">
              <i class="bi bi-cloud-arrow-down h4 align-middle mr-2"></i>
              <span>Descargar</span>
            </CButton>
          </CCol>
        </CRow>
        
        <CDataTable
          hover
          :fields="fields"
          :items="documents"
          :items-per-page="itemsPerPage">
          <template #numero="{item}">
            <td>
              <h4>{{ item.numero }}</h4>
              <div>
                {{ warrantyStatus[item.estado] }}
              </div>
              <div class="small">
                <i class="bi bi-calendar-check mr-1"></i>
                {{ moment(item.fecha_Creacion).format('DD/MM/YYYY') }}
              </div>
              <div class="small">
                <i class="bi bi-clock mr-1"></i>
                {{ moment(item.fecha_Creacion).format('HH:mm:ss') }}
              </div>
            </td>
          </template>
          <template #empresa="{item}">
            <td>
              <div>
                <i class="bi bi-building mr-1"></i>
                {{ item.directorio }}
              </div>
              <div>
                <strong>
                  <i class="bi bi-postcard mr-1"></i>
                  {{ item.identificacion }}
                </strong>
              </div>
              <div>
                <i class="bi bi-person-workspace mr-1"></i>
                {{ item.personal }}
              </div>
            </td>
          </template>
          <template #producto="{item}">
            <td>
              <div>
                {{ item.descripcion }}
              </div>
              <div>
                <strong>
                  {{ item.codigo }}
                </strong>
              </div>
              <div>
                <i class="bi bi-upc-scan mr-1"></i>
                {{ item.numero_Serial }}
              </div>
            </td>
          </template>
          <template #info="{item}">
            <a href="#"
              class="mb-2"
              @click="toggleDocument(item)">
              <CIcon class="text-dark" :name="item._toggled ?'cil-chevron-circle-up-alt':'cil-chevron-circle-down-alt'"></CIcon>
            </a>
          </template>
                    <template #details="{item}">
                        <CCollapse class="my-3" :show="item._toggled">
                            <CCol sm="6" class="d-inline-block">
                                <div class="ml-4">
                                  <strong>Código:</strong>
                                  {{item.codigo ? item.codigo : ''}}
                                </div>
                                <div class="ml-4">
                                  <strong>Número Serial: </strong>
                                  {{item.numero_Serial ? item.numero_Serial : ''}}
                                </div>
                                <div class="ml-4"><strong>Cantidad: </strong>{{item.cantidad ? item.cantidad : ''}}</div>
                                <div class="ml-4"><strong>Observaciones: </strong>{{item.observaciones ? item.observaciones : ''}}</div>
                            </CCol>
                            <CCol sm="6" class="d-inline-block">
                                <div class="ml-4"><strong>Comercial: </strong>{{item.personal ? item.personal : ''}}</div>
                                <div class="ml-4"><strong>Fecha Radicación: </strong>{{item.fecha_Creacion ? item.fecha_Creacion : ''}}</div>
                                <div class="ml-4"><strong>Fecha Actualización: </strong>{{item.fecha_Actualizacion ? item.fecha_Actualizacion : ''}}</div>
                                <CButton
                                  square
                                  size="sm"
                                  color="success"
                                  @click="goTo(item)"
                                  class="mb-2 ml-4 mt-2">
                                  <span class="">Agregar seguimiento</span>
                                  <!-- <CIcon class="text-success" name="cil-history"></CIcon> -->
                              </CButton>
                            </CCol>
                            <CDataTable
                              :fields="fieldsDetail"
                              :items="item.documentsDetail"
                              :items-per-page="10"
                              class="mt-3"
                              >
                                <template #estado_Garantia="{item}">
                                    <td>{{warrantyStatus[item.estado_Garantia]}}</td>
                                </template>
                                <template #fecha="{item}">
                                    <td align="right">{{ moment(item.fecha).format('DD/MM/YYYY') }}</td>
                                </template>
                                <template #fecha_Creacion="{item}">
                                    <td align="right">{{ moment(item.fecha_Creacion).format('DD/MM/YYYY HH:mm:ss') }}</td>
                                </template>
                                <template #nombre_ArchivoAdjunto="{item}">
                                    <td align="center">
                                      <CButton
                                        v-if="item.nombre_ArchivoAdjunto"
                                          :to="item.nombre_ArchivoAdjunto"    
                                      >
                                          <CIcon class="text-info" name="cil-paperclip"/>
                                      </CButton>
                                    </td>
                                </template>
                            </CDataTable>
                        </CCollapse>
                    </template>
                </CDataTable>
                <CPagination
                  :activePage.sync="page"
                  :pages="pageCount"
                  size="sm"
                  align="center"
                  @update:activePage="(value, a) => getData(value)"
                /> 
            </CCardBody>
        </CCard>
        <CElementCover  v-show="loading"/>

    </CContainer>
</template>
<script>
  import { ref } from "vue";
  import moment from "moment";

  import {
    dataGridGarantias,
    dataGridSeguimientosGarantia
  } from "@/api";

  const fields = [
    
    { 
      key: 'numero',
      label: 'Número',
      _style:'text-align:center;'
    },
    { 
      key: 'empresa', 
      label: 'Empresa',
      _style:'text-align:center;'
    },
    { 
      key: 'producto', 
      label: 'Producto',
      _style:'text-align:center;'
    },
    {
      key: 'info',
      label: '',
      _style:'text-align:center;'
    }
  ]

  const fieldsDetail = [
    { 
      key: 'nombre_ArchivoAdjunto', 
      label: '',
      _style:'text-align:center;'
    },   
    { 
      key: 'fecha',
      label: 'Fecha',
      _style:'text-align:center;'
    },
    { 
      key: 'estado_Garantia',
      label: 'Estado',
      _style:'text-align:center;'
    },
    { 
      key: 'observaciones', 
      label: 'Observaciones',
      _style:'text-align:center;'
    },
    { 
      key: 'fecha_Creacion', 
      label: 'Fecha Creación',
      _style:'text-align:center;'
    },
  ]

  export default {
    data() {
      return {
        documents: [],
        fields,
        fieldsDetail,
        itemsPerPage: 5,
        page: 1,
        pageCount: 1,
        warrantyStatus: {
          "RAD": "Radicada", 
          "PRE": "Producto Recibido", 
          "REV": "Revision", 
          "PRO": "En Proceso",
          "PEN": "Producto para Entrega",
          "FIN": "Finalizada",
          "REC": "Rechazada",
        },
        loading: false
      }    
    },
    methods: {
      moment,
      async getData(page, search){
        search

        this.loading = true;

        try {
          const { count, results } = await dataGridGarantias(this, page)
          
          this.documents = results.map(item => {
            item.documentsDetail = []
            return item
          });

          this.pageCount = parseInt(count / this.itemsPerPage);

          if (this.pageCount < (count / this.itemsPerPage)) {
            this.pageCount++;
          }
        } catch (error) {
          console.log(error)
          this.$store.commit('setAlert', {
                color: "danger",
                message: 'Error al cargar datos',
                show: 5
            })
        } finally {
          this.loading = false;
        }
      },
      async getDataDetail(item){
        try {
          this.loading = true
          const response = await dataGridSeguimientosGarantia(this, item.id_Garantia)
          
          item.documentsDetail = response

        } catch (error) {
          console.log(error)
          this.$store.commit('setAlert', {
                color: "danger",
                message: 'Error al cargar datos',
                show: 5
            })
        } finally {
          this.loading = false
        }
      },
      toggleDocument(item){
        this.$set(item, '_toggled', !item._toggled)
        this.$nextTick(() => { })
        if (item._toggled) {
          this.getDataDetail(item)
        }
      },
      goTo(item){
        this.$store.commit('set', ['selectedWarranty', item])

        this.$router.push(
          {
            path: `${this.rootPath}/${item.id_Garantia}/seguimientos/agregar`
          }
        )
      }
    },
    computed: {
    },
    setup() {
      const rootPath = ref("");

      return {
        rootPath
      }
    },
    async mounted() {
      this.rootPath = this.$router.currentRoute.fullPath;

      console.log(this.rootPath);

      await this.getData(this.page)
    }
  }
</script>
